import { render } from "./StatusPage.vue?vue&type=template&id=c25dc800&scoped=true&ts=true"
import script from "./StatusPage.vue?vue&type=script&lang=ts"
export * from "./StatusPage.vue?vue&type=script&lang=ts"

import "./StatusPage.vue?vue&type=style&index=0&id=c25dc800&scoped=true&lang=css"

import exportComponent from "/Users/jonas/Developer/Fliegen/KantineV2/webapp/shop-webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c25dc800"]])

export default __exports__